








import Vue from "vue";
import { Component } from "vue-property-decorator";

import { VCard, VCardText } from "vuetify/lib";

@Component({ components: { VCard, VCardText } })
export default class NoConfiguration extends Vue {}
